import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";
import iconClose from "../../assets/images/icon-login.png";
import calendarIcon from "../../assets/images/onleave/calendar.svg";

registerLocale("vi", vi);

const PopupActivateEmployee = ({ isOpen, onClose, defaultValues, onSubmit }) => {
  // Mặc định là ngày bấm mở hoạt động
  const [startTime, setStartTime] = useState(new Date());

  const submitHandler = (e) => {
    e.preventDefault();
    if (!startTime) return;
    onSubmit({ id: defaultValues?.id, startTime });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW={"480px"}>
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"25px 24px 24px 24px"}
          borderBottom={"1px solid var(--color-boder)"}
        >
          <Text
            fontSize={"18px"}
            fontWeight={600}
            lineHeight={"normal"}
            color="var(--color-black)"
          >
            Mở hoạt động nhân viên
          </Text>
          <Image src={iconClose} cursor={"pointer"} onClick={onClose} />
        </Flex>
        <form onSubmit={submitHandler}>
          <FormControl
            gap={"8px"}
            p={"24px 40px"}
            position={"relative"}
            zIndex={20}
          >
            <FormLabel
              mb={"6px"}
              fontSize={{ base: "12px" }}
              fontWeight={400}
              color="var(--color-label-employee)"
            >
              Ngày vào làm
            </FormLabel>
            <InputGroup>
              <DatePicker
                width="100%"
                selected={startTime}
                onChange={(date) => setStartTime(date)}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                placeholderText="dd/mm/yyyy"
                className="custom-datepicker datePickerStyle"
              />
              <InputRightElement pointerEvents="none" h={"44px"}>
                <Image src={calendarIcon} />
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <Flex justifyContent={"flex-end"} p={"0px 40px 24px 40px"}>
            <Button
              type="submit"
              borderRadius={"8px"}
              background={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              w={"164px"}
              h={"44px"}
              _hover={{
                filter: "brightness(90%)",
              }}
              _active={{
                filter: "brightness(90%)",
              }}
            >
              Mở hoạt động
            </Button>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default PopupActivateEmployee;
